// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

const borderSize = "1px";
const disabledAlpha = 0.5;
const size = "18px";
const left = 26;

export default {
    defaultProps: {
        css: css`
            display: flex;
            input {
                opacity: 0;

                + label {
                    margin-left: 5px;
                }

                & + label::before {
                    content: "";
                    position: absolute;
                    left: -${left}px;
                    top: 0;
                    height: ${size};
                    width: ${size};
                    border: 1px solid ${getColor("text")};
                    border-radius: 100%;
                    background: ${getColor("common.white")};
                }

                &:focus + label::before {
                    box-shadow: none;
                    border: 2px solid ${getColor("text")};
                }

                &:checked:not(:disabled) + label::before {
                    background: ${getColor("common.white")};
                    border: 2px solid ${getColor("text")};
                }

                &:checked:disabled + label::before {
                    background: ${getColor("common.white")};
                    border: 2px solid ${getColor("text")};
                }

                &:checked:disabled + label::after {
                    background: ${getColor("text")};
                    content: "";
                    display: block;
                    height: 10px;
                    width: 10px;
                    border-radius: 100%;
                    position: absolute;
                    left: -22px;
                    top: 4px;
                }

                &:checked + label::after {
                    background: ${getColor("text")};
                    content: "";
                    display: block;
                    height: 10px;
                    width: 10px;
                    border-radius: 100%;
                    position: absolute;
                    left: -22px;
                    top: 4px;
                }

                &:checked:focus + label::after {
                    background: ${getColor("common.ui2")};
                    content: "";
                    display: block;
                    height: 10px;
                    width: 10px;
                    border-radius: 100%;
                    position: absolute;
                    left: -22px;
                    top: 4px;
                }
                &:focus + label::after {
                    background: ${getColor("common.white")};
                    content: "";
                    display: block;
                    height: 11px;
                    width: 11px;
                    border-radius: 100%;
                    position: absolute;
                    left: -22px;
                    top: 4px;
                }
                &:disabled + label,
                &:focus:disabled + label {
                    cursor: not-allowed;
                    opacity: 0.5;
                }

                &:hover:not(:disabled) + label {
                    cursor: pointer;
                }

                &:hover:not(:disabled) {
                    box-shadow: none;
                    + label::before {
                        border-color: ${getColor("text")};
                        background: ${getColor("text")};
                    }
                }

                &:checked:input:checked:disabled + label::after {
                    background: ${getColor("text")};
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["radio"];
